// import { HubConnectionBuilder, LogLevel } from '@aspnet/signalr'
import { store } from '@/store'

export default {
  install (Vue) {
    var config = {}

    if (store.state.auth.user) {
      config.accessTokenFactory = () => store.state.auth.user.token
    }

    // const connection = new HubConnectionBuilder()
    //   .withUrl(`${process.env.ROOT_API}/message`, config)
    //   .configureLogging(logging => {
    //     logging.AddDebug()
    //     logging.SetMinimumLevel(LogLevel.Trace)
    //   })
    //   .build()

    /*
    const connection = new HubConnectionBuilder()
      .withUrl(`${process.env.ROOT_API}/message`, {
        accessTokenFactory: () => token
      })
      .configureLogging(logging => {
        logging.AddDebug()
        logging.SetMinimumLevel(LogLevel.Trace)
      })
      .build()
*/

    // use new Vue instance as an event bus
    const messageHub = new Vue()
    // every component will use this.$messageHub to access the event bus
    Vue.prototype.$messageHub = messageHub

    // Forward server side SignalR events through $messageHub, where components will listen to them
    // connection.on('TestMessage', message => {
    //   messageHub.$emit('test-message', message)
    // })

    // connection.on('FortnoxCustomerIntegrationMessage', message => {
    //   messageHub.$emit('fortnox-customer-integration-message', message)
    // })

    // connection.on('FortnoxCustomerIntegrationResult', hits => {
    //   messageHub.$emit('fortnox-customer-integration-result', hits)
    // })

    // connection.on('FortnoxCreateCustomersProgress', progress => {
    //   messageHub.$emit('fortnox-create-customers-progress', progress)
    // })

    // let startedPromise = null

    function start () {
      // startedPromise = connection.start({ withCredentials: false })
      //   .then(() => {
      //     // console.info('SignalR connected')
      //     connection.invoke('ClientToServer')
      //   })
      //   // eslint-disable-next-line
      //   .catch(err => {
      //     // console.error('Failed to connect with hub!', err)
      //     return new Promise((resolve, reject) =>
      //       setTimeout(() => start().then(resolve).catch(reject), 5000))
      //   })
      // return startedPromise
    }

    // connection.onclose(async () => {
    //   // console.info('Reconnecting with hub...')
    //   await start()
    // })

    start()
  }
}



// WEBPACK FOOTER //
// ./src/plugins/signalr.js